import { useQuery } from "@tanstack/react-query";
import { getThumbnailUrl } from "../api/files.api";
import { getAdminExplorerThumbnailUrl } from "../api/admin.api";

/**
 * Fetches a presigned thumbnail URL for a file.
 * Only fires for image files (mimeType.startsWith("image/")).
 * Cached for 14 minutes (just under S3 presigned URL's 15 min TTL).
 * When `explorerUserId` is set, uses admin read-only explorer endpoints.
 */
export function useThumbnailUrl(
  fileId: string,
  isImage: boolean,
  explorerUserId?: string
) {
  const { data } = useQuery({
    queryKey: explorerUserId
      ? ["thumbnail", "admin", explorerUserId, fileId]
      : ["thumbnail", fileId],
    queryFn: () =>
      explorerUserId
        ? getAdminExplorerThumbnailUrl(explorerUserId, fileId)
        : getThumbnailUrl(fileId),
    enabled: isImage,
    staleTime: 14 * 60 * 1000,
    gcTime: 15 * 60 * 1000,
  });
  return data?.url ?? null;
}
